import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import MultidimensionalCustomFormTemplate from "@beeldit/core/templates/MultidimensionalCustomFormTemplate";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    action: string
    className?: string;
    formDefaultValues?: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => any;
  backendFormErrors: any;
}

function ConfigurationProducerForm(props: Prop) {
  const { formRef, onSubmit, context, action, className, formDefaultValues } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const translations = {
    commission_percentage: t('commission_percentage'),
    shipment_percentage: t('shipment_percentage'),    
  };

  let schema: any = {
    type: "object",
    properties: {
      commission_percentage: {
        type: ['number', 'null'],
        title: translations.commission_percentage,
      },
      shipment_percentage: {
        type: ['number', 'null'],
        title: translations.shipment_percentage,
      },
    },
  };

  const uiSchema: UiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "commission_percentage",
              cols: "col-6",
            },
            {
              name: "shipment_percentage",
              cols: "col-6",
            },
          ]
        ]
      }
    ]
  };
  const customWidgets = {
    ...widgets,
    };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  const formTemplate = MultidimensionalCustomFormTemplate;

  return (
      <JSONSchemaForm
        noHtml5Validate
        showErrorList={false}
        ref={formRef}
        schema={finalSchema}
        uiSchema={uiSchema}
        widgets={customWidgets}
        formData={element}
        validator={validator}
        onChange={handleChange}
        onSubmit={onSubmit}
        onError={log("errors")}
        extraErrors={backendFormErrors}
        templates={{
          ObjectFieldTemplate: formTemplate,
        }}
      />
  );
}

export default ConfigurationProducerForm;
